import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "./SanjivanSuvidha.css";
import TrackFalseSlider from "../../Components/Slider/Slider";
import InputForm from "../../Components/InputForm/InputForm";
const InitialDeposite = ({ show, onHide, handleRoleSubmit, initDeposite }) => {
  const [initialDeposit, setInitialDeposit] = useState(301);
  const [payable, setPayable] = useState(601);
  const [initialdisabled, setInitialDisabled] = React.useState(false);

  const [data, setData] = useState({
    accholdername: "",
    bankName: "",
    ifsc: "",
    transactionRef: 0,
    amount: 0,
    transactionDate: null,
    typeoftransaction: null,
    statusId: 0,
    statusName: "",
    rejectedRemarks: [],
  });

  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  const [monthlyDeclaration, setMonthlyDeclarations] = useState(300);
  const payAble = (key: any, value: any) => {
    if (key === "initaldeposit") {
      setInitialDeposit(value.target.value + 1);
      setPayable(monthlyDeclaration + value.target.value + 1);
      onChange("amount", monthlyDeclaration + value.target.value + 1);
    }
    if (key === "monthlydeductions") {
      setMonthlyDeclarations(value.target.value);
      setPayable(initialDeposit + value.target.value);
      onChange("amount", monthlyDeclaration + value.target.value + 1);
    }
    //setPayable(initialDeposit + monthlyDeclaration)
  };

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        <div
          className="col-lg-2 col-sm-2 col-xs-2 "
          style={{ marginTop: "20px" }}
        >
          <div className="form-group">
            <label>Monthly Declarations</label>
          </div>
        </div>
        <div
          className="col-lg-6 col-sm-6 col-xs-6 "
          style={{ marginTop: "20px" }}
        >
          <TrackFalseSlider
            valuetext={(e) => payAble("monthlydeductions", e)}
            value={monthlyDeclaration}
            disabled={initialdisabled}
            // valueLabelDisplay="auto"
            min={300}
            max={5000}
            step={100}
          />
        </div>
        <div
          className="col-lg-2 col-sm-2 col-xs-2 "
          style={{ marginTop: "20px" }}
        >
          <div className="form-group">
            <InputForm
              placeholder={""}
              value={monthlyDeclaration}
              disabled={initialdisabled}
            />
          </div>
        </div>
        <div
          className="col-lg-2 col-sm-2 col-xs-2 "
          style={{ marginTop: "20px" }}
        >
          <div className="form-group">
            <label style={{ fontSize: "smaller" }}>
              (This amount will ne deducted monthly from your salary)
            </label>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="text-center btn-submit" onClick={handleRoleSubmit}>
          Submit
        </button>
        <button className="text-center btn-submit" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default InitialDeposite;
